import { useSearch } from "../../../hooks/UseSearch";
import ActionsBlockSearchBar from "./ActionsBlockSearchBar";
import { ActionsBlockContainer } from "../ActionsBlock.styles";
import ActionCards from "./ActionCards";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const ActionsBlock = () => {
  const { searchQuery, handleOnSearch } = useSearch();
  return (
    <ActionsBlockContainer>
      <ActionsBlockSearchBar
        searchQuery={searchQuery}
        handleOnSearch={handleOnSearch}
      />
      <DndProvider backend={HTML5Backend}>
        <ActionCards searchQuery={searchQuery} />
      </DndProvider>
    </ActionsBlockContainer>
  );
};

export default ActionsBlock;
